import { render } from "./FlashingApplianceMainList.vue?vue&type=template&id=3f22ff34"
import script from "./FlashingApplianceMainList.vue?vue&type=script&lang=js"
export * from "./FlashingApplianceMainList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__